module.exports = __webpack_public_path__ + "static/media/WaterBanner.5a566121.svg";